import React from 'react'
import LoginPage from 'scenes/loginPage'
const NonAuthLayout = () => {
  return (
    // <div>NonAuthLayout</div>
    <LoginPage></LoginPage>
  )
}

export default NonAuthLayout